var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-autocomplete",
    _vm._b(
      {
        attrs: {
          loading: _vm.searchInProgress,
          items: _vm.sortedMonsters,
          "item-text": "name",
          "item-value": "keyId",
          label: _vm.label,
          outlined: "",
          "no-filter": "",
          "return-object": "",
          dense: "",
          clearable: "",
          "hide-no-data": "",
          autocomplete: "off",
          "search-input": _vm.searchValue
        },
        on: {
          "update:searchInput": function($event) {
            _vm.searchValue = $event
          },
          "update:search-input": function($event) {
            _vm.searchValue = $event
          },
          change: _vm.returnValue
        },
        scopedSlots: _vm._u([
          {
            key: "item",
            fn: function({ item }) {
              return [
                [
                  _c("v-list-item-content", [
                    _vm._v(
                      " " +
                        _vm._s(item.name) +
                        " | " +
                        _vm._s(item.section) +
                        " | " +
                        _vm._s(item.source) +
                        " "
                    )
                  ])
                ]
              ]
            }
          }
        ]),
        model: {
          value: _vm.newMonster,
          callback: function($$v) {
            _vm.newMonster = $$v
          },
          expression: "newMonster"
        }
      },
      "v-autocomplete",
      _vm.$props,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }